module.exports = __webpack_public_path__ + "img/IMG_9592-Editar.74b6f728.jpg";